import {useNavigate} from "react-router-dom";
import styles from "./BaseBreadcrumb.module.css";

const BaseBreadcrumb = ({items}) => {
  const navigate = useNavigate();

  return (
    <nav
      className={styles.breadcrumb}
      aria-label="Breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span
            key={item.label}
            style={{display: "flex", alignItems: "center", gap: 6}}
          >
            {index > 0 && <span className={styles.breadcrumb__separator}>›</span>}
            {isLast ? (
              <span
                className={styles.breadcrumb__current}
                aria-current="page"
              >
                {item.label}
              </span>
            ) : (
              <button
                type="button"
                className={styles.breadcrumb__link}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default BaseBreadcrumb;
